import { takeLatest, call } from 'redux-saga/effects';

import Api from '../../../Api/Api';

import { mapFormFieldsToRequestObject } from './utils/utils';
import { FORM_FETCH } from './ducks';


function* fetchDataResultsSaga({ payload }) {
  const requestObject = mapFormFieldsToRequestObject(payload);

  yield call(Api.getPolicies, requestObject);
}


export default function* rootSaga() {
  yield takeLatest(FORM_FETCH, fetchDataResultsSaga);
}
